export const SvgIcon = () => ({
  styleOverrides: {
    root: {
      '& .secondary': {
        opacity: 0.4
      }
    }
  }
});